import React from "react";
import '../../styles/components/settings/control-group.scss';

export default function ControlGroup({children, label}: {children: React.ReactNode, label: string}) {
  return (
    <div className="control-group">
      <div className="label">{label}</div>
      <div className="items">{children}</div>
    </div>
  );
}

export function ControlGroupItem({children}:{children: React.ReactNode}){
  return <div className="control-group-item">{children}</div>
}